import TkPropertyMessageGet from "../../../utils/TkPropertyMessageGet";

const schema = {
  pattern: {
    // eslint-disable-next-line no-control-regex
    value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
    message: TkPropertyMessageGet("TKMSG_SCR0061E"),
  },
  maxLength: {
    value: 85,
    message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
  },
};

export { schema };
